<template>
  <b-form class="login-form" @submit.prevent="NewCode">
    <div class="form-item text-center forget-title">
      <span>Шинэ нууц үг үүсгэх</span>
      <p>Хамгийн багадаа 8 оронтой байх ёстой.</p>
      <p>Том, жижиг үсэг агуулсан байх ёстой.</p>
      <p>Тусгай тэмдэгт /!@#$%^&*/ агуулсан байх ёстой.</p>
    </div>
    <div class="form-item forget-form">
      <input
        type="password"
        class="form-control"
        v-model="nPassword"
        placeholder="Шинэ нууц үг"
        autofocus
        required
      />
    </div>
    <div class="form-item forget-form">
      <input
        type="password"
        class="form-control"
        v-model="newRepeatPassword"
        placeholder="Шинэ нууц үг давтах"
        autofocus
        required
      />
    </div>
    <div class="forget-form forget-btn">
      <input
        type="submit"
        class="btn forget-btn-inner"
        value="ҮРГЭЛЖЛҮҮЛЭХ"
        style="margin-top: 0"
        :disabled="isDisabled"
      />
      <span class="btn forget-btn-inner" @click="back">БОЛИХ</span>
    </div>
    <div class="form-item form-error-out" v-if="error">
      <div class="form-error" style="height: 100px">
        <div class="error-icon">
          <img src="@/assets/icon/error.png" alt="" />
        </div>
        <div class="error-message" style="padding-top: 10px">
          <p class="step3-error-p">{{ errorMessage }}</p>
          <p class="step3-error-p">{{ repeatErrorMessage }}</p>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: {
    userToken: String,
    cardHolderId: String,
  },
  data() {
    return {
      nPassword: "",
      newRepeatPassword: "",
      errorMessage: "",
      repeatErrorMessage: "",
      error: false,
      isDisabled: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    //add step
    stepadd() {
      this.$emit("finish");
    },
    //sendUserData
    NewCode() {
      this.isDisabled = true;
      var newpassword = this.nPassword.replace(/\s/g, "");
      //lowercase,uppercase,digits,special digits
      let isCheckPassword =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,25}$/.test(
          newpassword
        );
      var newrepeatpassword = this.newRepeatPassword.replace(/\s/g, "");
      // var isnum1 = /^\d+$/.test(newrepeatpassword);
      if (newpassword.length > 7 && newrepeatpassword.length > 7) {
        if (this.nPassword === this.newRepeatPassword) {
          if (isCheckPassword) {
            this.$insProgress.start();
            var tokenId = this.cardHolderId;
            var newPassword = this.nPassword;
            var userToken = this.userToken;

            this.$cardApi
              .post(
                "/auth/update/password",
                {
                  tokenId: userToken,
                  password: newPassword,
                  cardHolderKey: tokenId,
                },
                {
                  headers: {
                    "Accept-Language": "en-US",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                  },
                }
              )
              .then((response) => {
                if (response.status === 200) {
                  this.$auth.setToken(response.data.token);
                  this.$auth.setMe(response.data);
                  this.$router.go(-1);
                  this.$insProgress.finish();
                } else {
                  this.isDisabled = false;
                  this.errorMessage = response.data.message;
                  this.errorModal = true;
                  this.$insProgress.finish();
                }
              })
              .catch((error) => {
                // this.RedirectLogin();
                // this.$router.push({ name: "login" });
                this.errorMessage = error.response.data.message;
                this.error = true;
              });
          } else {
            this.isDisabled = false;
            this.errorMessage =
              "Таны оруулсан нууц үг том, жижиг үсэг, тоо, тусгай тэмдэгт /!@#$%^&*/ агуулсан байна";
            this.error = true;
          }
        } else {
          this.isDisabled = false;
          this.errorMessage =
            "Таны шинэ нууц үг давтан нууц үг хоорондоо таарахгүй байна";
          this.error = true;
        }
      } else {
        this.isDisabled = false;
        this.errorMessage = "Нууц үг хамгийн багадаа 8 оронтой байна";
        this.error = true;
      }
    },
    //check username name user input
    checkusername() {
      var newpassword = this.nPassword.replace(/\s/g, "");
      // var isnum = /^\d+$/.test(newpassword);
      if (newpassword.length < 6) {
        this.error = true;
        this.errorMessage = "Шинэ нууц үг хамгийн багадаа 6 оронтой байна ?";
        this.isDisabled = true;
      } else {
        this.error = false;
        this.errorMessage = "";
        this.isDisabled = false;
      }
    },
    checkusername2() {
      var newrepeatpassword = this.newRepeatPassword.replace(/\s/g, "");
      // var isnum = /^\d+$/.test(newrepeatpassword);
      if (newrepeatpassword.length < 6) {
        this.error = true;
        this.repeatErrorMessage =
          "Давтан нууц үг хамгийн багадаа 6 оронтой байна ?";
        this.isDisabled = true;
      } else {
        this.error = false;
        this.repeatErrorMessage = "";
        this.isDisabled = false;
      }
    },
    //back to Login
    back() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style>
.step3-error-p {
  padding: 0px 10px 10px 10px !important;
  margin: 0 !important;
}
</style>
